import React from "react";

import { useCurrentProjectContext } from "@editor/contexts/CurrentProjectContext";
import { isFeatureEnabled } from "@editor/infra/featureFlags";

import { GenerateTemplatesForm } from "@/components/GenerateTemplatesForm";
import Button from "@replo/design-system/components/button/Button";

import { DeployButton } from "../next-gen/components/DeployButton";
import EditorChat from "./components/EditorChat";
import ManageChats from "./components/ManageChats";
import ManageFunnels from "./components/ManageFunnels";
import ReactInlineEditor from "./components/ReactInlineEditor";
import { useIframeMessaging } from "./useIframeMessaging";

function ReactEditor() {
  const isReaplo = isFeatureEnabled("reaplo");
  const { project } = useCurrentProjectContext();
  useIframeMessaging();

  if (!project) {
    return null;
  }

  const siteUrl = `https://${project.shopDomainPrefix}.reploshops.com`;

  if (!isReaplo) {
    window.location.href = `/projects/${project.id}`;
    return null;
  }
  return (
    <div className="flex h-screen gap-3 p-3">
      <div className="flex h-full flex-col gap-5">
        <div className="flex h-full min-h-0 max-h-[100px] max-w-md flex-col gap-4 rounded-md border p-4">
          <h1 className="text-2xl font-bold">Current Funnel</h1>
          <ManageFunnels />
        </div>
        <GenerateTemplatesForm />

        <div className="flex h-full min-h-0 max-w-md flex-col gap-4 rounded-md border p-4">
          <h1 className="text-2xl font-bold">Chat For Editing</h1>
          <ManageChats />
          <EditorChat />
        </div>
      </div>

      <ReactInlineEditor />
      <div className="flex flex-col gap-4 w-36">
        <DeployButton />
        <Button
          variant="link"
          onClick={() => {
            window.open(siteUrl, "_blank");
          }}
          UNSAFE_className="whitespace-normal break-words"
          layoutClassName="w-full"
          title={siteUrl}
        >
          {siteUrl}
        </Button>
      </div>
    </div>
  );
}

export default ReactEditor;
